import React from "react";
import BlogImg from "../assets/images/Blog.png";
import "./Blog.css";
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useParams } from "react-router-dom";

const BlogPage = () => {
      const { title, id } = useParams();
    
    return (
        <div className="blog-container home-container1">
            {/* Banner Section */}
            <div
                className="banner-section"
                style={{ backgroundImage: `url(${BlogImg})` }}
            >
                <div className="banner-overlay"></div>
                <div className="banner-content">
                    <h1>{title}</h1>
                    <p className="breadcrumb-text">
                        <span>{id}</span> <span className="arrow">→</span> <span>Blog</span>
                    </p>
                </div>
            </div>

            {/* Main Content */}
            <Container className="mt-5 ">
                <Row>
                    <Col sm={8} className="mb-3">
                        <div className="blog-main">
                            {/* Left Side - Blog Posts */}
                            <div className="blog-posts">
                                <div className="post-card">
                                    <img src={BlogImg} alt="Blog" className="post-image" />
                                    <div className="post-meta">
                                        <span>👤 Plots Verified</span>
                                        <span>📅 June 9, 2024</span>
                                        <span>🏠︎ Property</span>
                                    </div>
                                    <a className="post-title">
                                        Emphasizes the importance of continuous learning and intellectual
                                    </a>
                                    <p className="post-desc">
                                        Plot Residence promotes sustainable transportation options, with
                                        dedicated spaces. Welcome to Plots Verified Residence, where sustainability
                                        meets comfort in every corner. In this blog post, we’ll explore the
                                        green innovations seamlessly integrated into the fabric of EcoLand.
                                        Plot Residence promotes sustainable transportation options, with
                                        dedicated spaces. <br/>Welcome to Plots Verified Residence, where sustainability
                                        meets comfort in every corner. In this blog post, we’ll explore the
                                        green innovations seamlessly integrated into the fabric of EcoLand.
                                        Plot Residence promotes sustainable transportation options, with
                                        dedicated spaces.  <br/>Welcome to Plots Verified Residence, where sustainability
                                        meets comfort in every corner. In this blog post, we’ll explore the
                                        green innovations seamlessly integrated into the fabric of EcoLand.
                                        Plot Residence promotes sustainable transportation options, with
                                        dedicated spaces.  <br/>Welcome to Plots Verified Residence, where sustainability
                                        meets comfort in every corner. In this blog post, we’ll explore the
                                        green innovations seamlessly integrated into the fabric of EcoLand.
                                    </p>
                                    <a className="post-title">
                                        Residence is not just a place to live it’s asustainable way of life.
                                    </a>
                                    <p className="post-desc">
                                        Plot Residence promotes sustainable transportation options, with
                                        dedicated spaces. Welcome to Plots Verified Residence, where sustainability
                                        meets comfort in every corner. In this blog post, we’ll explore the
                                        green innovations seamlessly integrated into the fabric of EcoLand.
                                        Plot Residence promotes sustainable transportation options, with
                                    </p>
                                        
                                    <img src={BlogImg} alt="Blog" className="post-image" />
                                        <p>
                                         <br/>Welcome to Plots Verified Residence, where sustainability
                                        meets comfort in every corner. In this blog post, we’ll explore the
                                        green innovations seamlessly integrated into the fabric of EcoLand.
                                        Plot Residence promotes sustainable transportation options, with
                                        dedicated spaces.  <br/>Welcome to Plots Verified Residence, where sustainability
                                        meets comfort in every corner. In this blog post, we’ll explore the
                                        green innovations seamlessly integrated into the fabric of EcoLand.
                                        Plot Residence promotes sustainable transportation options, with
                                        dedicated spaces.  <br/>Welcome to Plots Verified Residence, where sustainability
                                        meets comfort in every corner. In this blog post, we’ll explore the
                                        green innovations seamlessly integrated into the fabric of EcoLand.
                                    </p>
                                   
                                </div>
                            </div>
                        </div>
                         
                    </Col>
                    <Col sm={4} className="mb-3">
                        <aside className="blog-sidebar">
                             
                            <div className="sidebar-card">
                                <h3>Post Categories</h3>
                                <ul>
                                    <li>Apartment (1)</li>
                                    <li>Banglow (2)</li>
                                    <li>Modern Houses (3)</li>
                                    <li>Property (5)</li>
                                    <li>Real Estate (5)</li>
                                </ul>
                            </div>

                            {/* Recent Posts */}
                            <div className="sidebar-card">
                                <h3>Recent Posts</h3>
                                <ul className="recent-posts">
                                    <li>
                                        <img src={BlogImg} alt="post" />
                                        <div>
                                            <p>Emphasizes The Importance Of Continuous Learning</p>
                                            <span>📅 June 9, 2024</span>
                                        </div>
                                    </li>
                                    <li>
                                        <img src={BlogImg} alt="post" />
                                        <div>
                                            <p>Enrich Your Mind Envision Your Future</p>
                                            <span>📅 April 17, 2024</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                             <div className="mt-5 mb-5 formData">
                                <Form>
                                    <h5>Contact the owner</h5>
                                    <hr />
                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label style={{color:'white'}}>Name</Form.Label>
                                        <Form.Control type="text" placeholder="Name" />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label  style={{color:'white'}} >Email address</Form.Label>
                                        <Form.Control type="email" placeholder="Enter email" />
                                    </Form.Group> 
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label  style={{color:'white'}} >Message</Form.Label>
                                        <Form.Control as="textarea" placeholder="Message..." rows={5} />
                                    </Form.Group> 
                                    
                                    <button  className="details-button">
                                        Submit
                                    </button>
                                </Form>
                            </div>
                        </aside>
                    </Col>
                </Row>
            </Container>


            {/* Right Side - Sidebar */}

        </div>

    );
};

export default BlogPage;
